import ContentManager from './base';
import CurriculumViewer from '../components/curriculum.viewer';
import Panel from '../panels';
import Remote from '../remote';
import Utils from '../utils';
import flash from '../flash';

export default class CircleContentViewer extends ContentManager {
  constructor(context, remote, options) {
    super(context, remote, options);
    this.curriculumViewer = new CurriculumViewer(this.context);
  }

  buildModal(cnt, hideDescription) {
    if (typeof this.panel == 'undefined') {
      this.panel = new Panel(Panel.CIRCLE, '<div class="lp--panelLoader"></div>', {
        fullscreen: this.options.fullscreen,
      });
    }
    return new Promise((resolve, reject) => {
      this.panel.updateContent(cnt);

      this.attach(hideDescription);

      this.panel.eventSource.on('willHide.panel', () => {
        this.detach();
      });

      this.panel.eventSource.on('willHide.panel', () => {
        this.panel.content.find('.pr2--activityItem').off('.panel');
      });

      this.panel.content.find('.pr2--activityItem').on(Utils.interactionEvent, (ev) => {
        this.options.viewer.openByUUID(ev.currentTarget.getAttribute('data-uuid'));
      });

      this.panel.content.find('.lp--js-openAlexandriaViewerModal').on(Utils.interactionEvent, (ev) => {
        ev.preventDefault();
        this.curriculumViewer.view();
      });

      let link_visible = false;
      this.panel.content.find('.lp--js-shareCircleLink').on(Utils.interactionEvent, (ev) => {
        ev.preventDefault();
        if (link_visible) {
          $(ev.target).html(i18n.__('share_link_copy'));
        } else {
          let remote = new Remote('/my-loops/' + this.context.id + '/share_link', {});
          remote.get('').then((result) => {
            let el = $(ev.target);
            el.html(result.share_link);
            var range = document.createRange();
            range.selectNode(el[0]);
            window.getSelection().removeAllRanges();
            window.getSelection().addRange(range);
          });
        }
        link_visible = !link_visible;
      });

      resolve(this.panel);
    });
  }

  loadModal(hideDescription = false) {
    this.panel = new Panel(Panel.CIRCLE, '', {
      fullscreen: this.options.fullscreen,
    });
    Utils.promiseWithFuse(
      () => {
        this.panel.updateContent('<div class="lp--panelLoader"></div>');
      },
      this.load().then((data) => {
        this.buildModal(data, hideDescription);
        this.setupModal(this.panel);
        return this.panel;
      }),
      400,
    );
    return Promise.resolve(this.panel);
  }

  parseResult(content) {
    return content;
  }

  load() {
    return this.remote
      .get(this.options.getURLFor(ContentManager.Content.Circle, this.context, this.options), { type: 'html' })
      .on('noAccess', () => {
        // Redirect to an url we want to return to after the login
        window.location.replace('/editor/' + this.options.circle_id);
      })
      .then((result) => {
        try {
          this.immersiveReader.buildFromContent(result, 'loop');
        } catch (error) {
          console.error(error);
        }
        return this.parseResult(result);
      })
      .catch((err) => {
        flash(i18n.__('error_behavior_load_failed'));
      });
  }
}
